/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Kiestoetsvolume',
  ringtoneVolume: 'Beltoonvolume',
  callVolume: 'Oproepvolume',
  muteCalls: 'Oproepen dempen',
  outputDevice: 'Output-apparaat',
  inputDevice: 'Input-apparaat',
  micPermission: 'Machtiging microfoon',
  noDevice: 'Geen apparaat',
  checkMicPermission: 'Machtigingen controleren',
  micNoPermissionMessage: 'De app is niet gemachtigd om microfoon te gebruiken',
  noLabel: 'Onbekend apparaat',
  notSetSinkIdTip:
    'Uw huidige browsermachtigingen zijn niet ingesteld om ons toegang te geven tot uw audio-output-apparaten. {clickHereLink} om te zien hoe u dit kunt instellen.',
  noLabelTip:
    'Uw huidige browsermachtigingen zijn niet ingesteld om ons toegang te geven tot uw audio-input-apparaten.',
  clickHere: 'Klik hier',
  defaultOutputDevice: 'Standaard output-apparaat',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
